
import { computed, defineComponent, watchEffect } from 'vue';
import { createRadioBase } from 'JS/components/blain-form/BRadioBase';
import { format } from 'date-fns';

const { withRadioBaseProps, useRadioBase } = createRadioBase<Date>();

export default defineComponent({
	props: {
		selected: Boolean,
		selectedDate: Date,
		...withRadioBaseProps(),
	},
	setup (props, { emit }) {
		return {
			...useRadioBase(props, emit),
			day: computed(() => format(props.value, 'EEEE')),
			dayShort: computed(() => format(props.value, 'E')),
			dateLabel: computed(() => format(props.value, 'MM/dd')),
		};
	}
});
